export default {
  siteTitle: 'AllChinaBuy Spreadsheet — Produits, Vendeurs & Guides d\'Achat Intelligents',
  siteDescription: 'Explorez les ressources AllChinaBuy spreadsheet, les trouvailles produits, les guides vendeurs, les informations QC, les coûts d\'expédition, les avis et les guides pratiques d\'achat en Chine — tout organisé en un seul endroit.',
  siteKeywords: 'AllChinaBuy, AllChinaBuy spreadsheet, AllChinaBuy avis, achat Chine, guide spreadsheet',

  navHome: 'Accueil',
  navShoppingGuide: 'Guide d\'Achat',
  navCategories: 'Catégories',
  navSpreadsheet: 'Spreadsheet',
  navProducts: 'Produits',
  navSellers: 'Vendeurs',
  navGuides: 'Guides',
  navReviews: 'Avis',
  navShipping: 'Expédition',
  navQC: 'QC',
  navCoupons: 'Coupons',
  navAbout: 'À propos',
  navContact: 'Contact',

  heroH1: 'AllChinaBuy Spreadsheet — Trouvez des Produits, Vendeurs & Guides d\'Achat',
  heroSub: 'Explorez les ressources AllChinaBuy spreadsheet, les trouvailles produits, les guides vendeurs, les informations QC, les coûts d\'expédition, les avis et les guides pratiques d\'achat en Chine.',
  ctaExplore: 'Explorer AllChinaBuy Spreadsheet',
  ctaBuyNow: 'Acheter Maintenant',
  ctaReview: 'Lire l\'Avis Complet',
  ctaVisit: 'Visiter le Site Principal',
  ctaMain: 'AllChinaBuy Spreadsheet',

  categoryTitle: 'Parcourir les Catégories',
  categorySubtitle: 'Trouvez exactement ce dont vous avez besoin dans nos collections spreadsheet',
  categories: [
    { name: 'Chaussures', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
    { name: 'Sweats à Capuche/Pulls', url: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html' },
    { name: 'T-Shirts', url: 'https://kaspreadsheet.com/category-913-T-Shirts.html' },
    { name: 'Vestes', url: 'https://kaspreadsheet.com/category-914-Jackets.html' },
    { name: 'Pantalons/Shorts', url: 'https://kaspreadsheet.com/category-915-Pants%2FShorts.html' },
    { name: 'Couvre-Chefs', url: 'https://kaspreadsheet.com/category-916-Headwear.html' },
    { name: 'Ensembles', url: 'https://kaspreadsheet.com/category-917-Sets.html' },
    { name: 'Sous-Vêtements', url: 'https://kaspreadsheet.com/category-918-underwear%2Funderpants.html' },
    { name: 'Maillots', url: 'https://kaspreadsheet.com/category-919-Jersey.html' },
    { name: 'Accessoires', url: 'https://kaspreadsheet.com/category-920-Accessories.html' },
    { name: 'Sacs', url: 'https://kaspreadsheet.com/category-921-Bags.html' },
    { name: 'Ceintures', url: 'https://kaspreadsheet.com/category-922-Belts.html' },
    { name: 'Parfums', url: 'https://kaspreadsheet.com/category-923-Perfumes.html' },
    { name: 'Autres', url: 'https://kaspreadsheet.com/category-924-Other+Stuff.html' },
  ],

  articleTitle: 'Guides & Articles AllChinaBuy Spreadsheet',
  articleSubtitle: 'Des ressources approfondies pour vous aider à naviguer AllChinaBuy comme un pro',
  readMore: 'Lire Plus',
  article1Title: 'AllChinaBuy Spreadsheet 2026: Guide Complet pour les Acheteurs Intelligents',
  article1Desc: 'Découvrez comment utiliser le spreadsheet AllChinaBuy pour trouver les meilleurs produits, vendeurs de confiance et économiser sur vos achats en Chine.',
  article1Meta: 'Mis à jour août 2026 · 8 min de lecture',
  backToHome: 'Retour à l\'Accueil',
  relatedArticles: 'Articles Connexes',
  shareArticle: 'Partager ce Guide',

  footerDisclaimer: 'AllChinaBuySpreadsheet.best est une ressource d\'information indépendante et n\'est pas affiliée ni approuvée par AllChinaBuy.',
  footerLinks: 'Liens Rapides',
  footerLegal: 'Légal & Sécurité',
  footerPrivacy: 'Politique de Confidentialité',
  footerTerms: 'Conditions d\'Utilisation',
  footerEditorial: 'Politique Éditoriale',
  footerSafety: 'Guide de Sécurité',
  footerCopyright: '© 2026 AllChinaBuySpreadsheet.best. Tous droits réservés.',
  footerLanguage: 'Langue',

  articleIntro: 'Introduction',
  articleTOC: 'Table des Matières',
  articleConclusion: 'Conclusion',
  articleCTA: 'Prêt à faire des achats plus intelligents ?',
  articleCTABtn: 'Explorer AllChinaBuy Spreadsheet',
  articleInternalLink: 'Retournez à notre page d\'accueil AllChinaBuy Spreadsheet pour plus de ressources et guides d\'achat.',

  selectCategory: 'Sélectionner une Catégorie',
  browseAll: 'Parcourir Toutes les Catégories',

  trustIndependent: 'Ressource Indépendante',
  trustVerified: 'Information Vérifiée',
  trustUpdated: 'Régulièrement Mis à Jour',
  trustCommunity: 'Communautaire',
};